import React from 'react';

import '../../App.css';

const Home = (props) => {

  const t = props.t;

  return (
    <section className="App-content">
      {t('pages.homeWelcomeMsg')}
    </section>
  );
};

export default Home;